import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Accordion, AccordionSummary, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const empresa = [
  {
    nombre: "Páginas web",
    user: "Certificados del SEGIP, OEP, Policía Boliviana",
  },
  { nombre: "Tiendas online", user: "Nacimiento" },
  { nombre: "Estados Financieros", user: "Matrimonio" },
  { nombre: "Auditorías", user: "Carnet de Identidad" },
  { nombre: "Documentos empresariales", user: "Antecedentes Policiales" },
  { nombre: "Manuales de recursos humanos", user: "Certificados de estudio" },
  { nombre: "Manuales de políticas", user: "Libretas" },
  { nombre: "Folletos", user: "Cartas de recomendación" },
  { nombre: "Materiales de Entrenamiento", user: "Titulos de Bachiller" },
  { nombre: "LEGALES:", user: "Hojas de Vida" },
  { nombre: "Garantías", user: "Formularios de aplicación" },
  {
    nombre: "Contratos",
    user: "Registros médicos: certificados de vacunación e informes médicos",
  },
  { nombre: "Términos y condiciones", user: "Transcripciones" },
  {
    nombre: "Testimonios de Construcción",
    user: "Testimonios y folios reales",
  },
  { nombre: "Fundempresas", user: "Estractos Bancarios" },
  { nombre: "TERMINOLOGIAS TECNICAS", user: "" },
  { nombre: "Guias de usuario", user: "" },
  { nombre: "Instrucciones de uso", user: "" },
  { nombre: "Informes", user: "" },
];

const TraduccionLista = () => {
  return (
    <Box>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon color="primary" />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ background: "#009999" }}
        >
          <Typography
            variant="h6"
            align="center"
            sx={{
              background: "#009999",
              color: "#fff",
              width: "100%",
            }}
          >
            <b>DOCUMENTOS QUE TRADUCIMOS</b>
          </Typography>
        </AccordionSummary>
        <TableContainer component={Paper} sx={{ width: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <b>EMPRESA</b>
                </TableCell>
                <TableCell align="center">
                  <b>PERSONA</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {empresa.map((row) => (
                <StyledTableRow key={row.nombre}>
                  <StyledTableCell component="th" scope="row">
                    {row.nombre}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row.user}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Accordion>
    </Box>
  );
};

export default TraduccionLista;
